<template>
  <div v-if="content">
    <v-row>
      <v-col cols="10" offset="1">
        <v-row>
          <v-col cols="12">
            <h2
              class="headline mb-4"
              v-text="content.exercise_culture.title"
            ></h2>

            <p
              v-for="(item, index) in content.exercise_culture.description"
              :key="index"
              v-text="item"
            />
          </v-col>
          <v-col cols="6" v-for="item in items" :key="item.id">
            <v-card
              light
              :to="`/users/project/${$route.params.id}/${item.slug}`"
              height="100%"
            >
              <v-card-title>
                <h3 class="overline" v-if="item.part">{{ item.part }}</h3>
              </v-card-title>
              <v-card-subtitle>
                <h2 class="headline black--text">{{ item.title }}</h2>
                {{ item.text }}
              </v-card-subtitle>

              <v-card-actions>
                <v-btn light color="amber" class="mb-2">View</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserCultureMenu",
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    console.log(data);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      items: [
        {
          id: 0,
          title: "Language",
          part: "Part 1",
          text: "What is the lingo and vernacular",
          slug: "culture/language/shared",
        },
        {
          id: 1,
          title: "Knowledge",
          part: "Part 2",
          text: "Local knowledge and insider information",
          slug: "culture/knowledge/shared",
        },
        {
          id: 2,
          title: "Behaviour",
          part: "Part 3",
          text: "Norms, values and expectations",
          slug: "culture/behaviour/shared",
        },
        {
          id: 3,
          title: "Dynamics",
          part: "Part 4",
          text: "Politics, sub cultures and movements",
          slug: "culture/dynamics/shared",
        },
      ],
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {},
  },
};
</script>

<style lang="scss"></style>
